import React from 'react';

import styles from './Modal.module.scss';

function Modal(props: ModalProps) {
    return (
        <div
            className={styles.modal}
            style={{
                display: props.show ? "block" : "none"
            }}
            onClick={(e) => {
                if (e.target == e.currentTarget) {
                    props.onClose();
                }
            }}
        >
            <div className={styles.modalfloat}>
                <div className={styles.modalheader}>
                    <h1>{props.title}</h1>
                    <div
                        className={styles.close}
                        onClick={() => props.onClose()}
                    >
                        <i className="fa fa-times"></i>
                    </div>
                </div>
                <div className={styles.modalcontent}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

class ModalProps {
    title?: string;
    children!: any;
    show!: boolean;
    onClose!: Function;
}

export default Modal;